import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ConclusioniWarningsService } from './warnings/conclusioni.warnings';
import { ConclusioniFieldValidators } from './validators/conclusioni.field-validators';

@NgModule({
    declarations: [],
    imports: [CommonModule, ReactiveFormsModule],
    providers: [ConclusioniWarningsService, ConclusioniFieldValidators],
})
export class ConclusioniFormModule {}
